// toastr pulls in jQuery (~84 kB). Load it lazily on first toast so it stays
// out of the initial bundle.
export const handleToastr = async (msg, type = "success", timeout = 1500) => {
    const { default: toastr } = await import("toastr");
    toastr.options = {
        positionClass: "toast-top-right",
        hideDuration: 300,
        timeOut: timeout,
        closeButton: true,
    };
    toastr.clear();
    setTimeout(() => {
        if (type == "success") {
            return toastr.success(msg);
        } else if (type == "warning") {
            return toastr.warning(msg);
        } else if (type == "error") {
            return toastr.error(msg);
        }
    }, 300);
};
